import React from 'react'
import { Link } from "react-router-dom"
import PropTypes from 'prop-types'
import { Row, Col, Form, Input, Typography, Button, Checkbox, message } from 'antd'
import { withRouter } from 'react-router'
import { Redirect } from 'react-router-dom'
import StorageUtils from '../../utils/StorageUtils'
import MemoryUtils from '../../utils/MemoryUtils'
import { UserOutlined, LockOutlined } from '@ant-design/icons'
import { reqLogin } from '../../api'

const { Title } = Typography

class Login extends React.Component {
    state = {
        isLogin: false,
    }
    
    onFinish = async (values) => {
        const result = await reqLogin(values.username, values.password)
        
        if (result.code === 0) {
            StorageUtils.saveUser({ access: result.data.access, refresh: result.data.refresh })
            MemoryUtils.user = { access: result.data.access, refresh: result.data.refresh }
            this.props.setUserState(true)
            this.setState({'isLogin': true})
        } else {
            message.error(result.message)
        }
    }

    componentDidMount() {
        const user = StorageUtils.getUser()
        const pathSnippets = this.props.location.pathname.split('/').filter(i => i)

        this.props.setPathSnippetsState(pathSnippets)
        
        if (user) {
            this.setState({'isLogin': true})
        }
    }

    render() {
        const { isLogin } = this.state
        
        return (
            isLogin ? <Redirect to="/user/account" /> :
            (
                <React.Fragment>
                    <Row justify="center">
                        <Col>
                            <Title level={3}>User Login</Title>
                        </Col>
                    </Row>
                    <Row justify="center">
                        <Col span={8}>
                            <Form name="user_login" className="login-form" initialValues={{ remember: true }} onFinish={this.onFinish}>
                                <Form.Item name="username" 
                                    rules={[
                                        { required: true, message: 'Please input your Username!' },
                                    ]}
                                >
                                    <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Username" />
                                </Form.Item>
                                <Form.Item name="password" 
                                    rules={[
                                        { required: true, message: 'Please input your Password!' }
                                    ]}
                                >
                                    <Input prefix={<LockOutlined className="site-form-item-icon" />} type="password" placeholder="Password" />
                                </Form.Item>
                                <Form.Item>
                                    <Form.Item name="remember" valuePropName="checked" noStyle>
                                        <Checkbox>Remember me</Checkbox>
                                    </Form.Item>
                                    <Link className="login-form-forgot" to="/user/forgetpwd">Forgot password</Link>
                                </Form.Item>
                                <Form.Item>
                                    <Button type="primary" htmlType="submit" className="login-form-button" block>Log in</Button>
                                </Form.Item>
                            </Form>
                        </Col>
                    </Row>
                </React.Fragment>
            )
            
        )
    }
}

Login.propTypes = {
    setUserState: PropTypes.func,
    setPathSnippetsState: PropTypes.func
}

export default withRouter(Login)